import React from "react";
import { Link } from "react-router-dom";

function DropDownListItem({ item, index, length }) {
  return (
    <li
      key={item.id}
      className={`text-xs capitalize font-medium text-black hover:text-pink-600 ${
        index !== length - 1 ? "border-b border-b-gray-200" : ""
      }`}
    >
      <Link
        to={item.path}
        smooth={true}
        offset={-50}
        duration={500}
        // className="font-semibold"
      >
        {item.title}
      </Link>
    </li>
  );
}

export default DropDownListItem;
